import { Module, GlobalContainer, injectable, decorate } from 'mana-syringe';
import { EventEmitter } from 'eventemitter3';
import { DisplayObjectPool } from './DisplayObjectPool';
import { DefaultSceneGraphService, SceneGraphService } from './services/SceneGraphService';
import { CircleUpdater, EllipseUpdater, GeometryAABBUpdater, GeometryUpdaterFactory, LineUpdater, PathUpdater, PolylineUpdater, RectUpdater } from './services/aabb';
import { TextService } from './services/text';
import { TextUpdater } from './services/aabb/TextUpdater';
import { OffscreenCanvasCreator } from './services/text/OffscreenCanvasCreator';
import { DefaultSceneGraphSelector, SceneGraphSelector, SceneGraphSelectorFactory } from './services/SceneGraphSelector';
import { clampedMergeNumbers, parseNumber, mergeColors, parseColor, updateGeometry, updateLocalPosition, updateOffsetPath, updateClipPath, updateZIndex, updateOffsetDistance, updateOrigin, updateTransform, updateTransformOrigin, updateText, parseTransform, mergeTransforms, parsePath, parsePoints, mergePaths, mergeNumbers, mergeNumberLists, parseFilter, updateAnchor, parseLineDash, parseLengthOrPercent, mergeDimensions, updateTextTransform, updateInherit } from './property-handlers';
export var globalContainer = GlobalContainer; // some properties support 'inherit' value

export var INHERIT_PROPERTIES = ['textAlign', 'fontSize', 'fontFamily', 'fontWeight', 'fontStyle'];
export var stylePropertyParserFactory = {};
export var stylePropertyUpdaterFactory = {};
export var stylePropertyMergerFactory = {};
export function addPropertyHandler(property, parser, merger, updater) {
  if (parser) {
    stylePropertyParserFactory[property] = parser; // register({ token: { token: StylePropertyParser, named: property }, useValue: parser });
  }

  if (merger) {
    stylePropertyMergerFactory[property] = merger; // register({ token: { token: StylePropertyMerger, named: property }, useValue: merger });
  }

  if (updater) {
    if (!stylePropertyUpdaterFactory[property]) {
      stylePropertyUpdaterFactory[property] = [];
    }

    stylePropertyUpdaterFactory[property].push(updater); // register({ token: { token: StylePropertyUpdater, named: property }, useValue: updater });
  }
}
export function addPropertiesHandler(properties, parser, merger, updater) {
  for (var i = 0; i < properties.length; i++) {
    addPropertyHandler(properties[i], parser, merger, updater);
  }
}
export var containerModule = Module(function (register) {
  decorate(injectable(), EventEmitter); // bind DisplayObject pool

  register(DisplayObjectPool); // bind Selector

  register(DefaultSceneGraphSelector);
  register({
    token: SceneGraphSelectorFactory,
    useFactory: function useFactory(context) {
      return function () {
        return context.container.get(SceneGraphSelector);
      };
    }
  }); // bind scenegraph service

  register({
    token: SceneGraphService,
    useClass: DefaultSceneGraphService
  }); // bind text service

  register(OffscreenCanvasCreator);
  register(TextService); // bind aabb updater

  register(CircleUpdater);
  register(EllipseUpdater);
  register(RectUpdater);
  register(TextUpdater);
  register(LineUpdater);
  register(PolylineUpdater);
  register(PathUpdater);
  register({
    token: GeometryUpdaterFactory,
    useFactory: function useFactory(context) {
      var cache = {};
      return function (tagName) {
        if (!cache[tagName]) {
          if (context.container.isBoundNamed(GeometryAABBUpdater, tagName)) {
            cache[tagName] = context.container.getNamed(GeometryAABBUpdater, tagName);
          }
        }

        return cache[tagName];
      };
    }
  }); // bind handlers for properties

  addPropertiesHandler(['opacity', 'fillOpacity', 'strokeOpacity', 'offsetDistance'], parseNumber, clampedMergeNumbers(0, 1), undefined);
  addPropertiesHandler(['shadowBlur'], parseNumber, clampedMergeNumbers(0, Infinity), undefined); // support percent

  addPropertiesHandler(['r', 'rx', 'ry', 'width', 'height', 'fontSize', 'lineWidth', 'dx', 'dy'], parseLengthOrPercent, // @ts-ignore
  mergeDimensions, undefined);
  addPropertiesHandler(['lineDash'], parseLineDash, // @ts-ignore
  mergeNumberLists, undefined);
  addPropertiesHandler(['x1', 'x2', 'y1', 'y2', 'lineDashOffset', 'shadowOffsetX', 'shadowOffsetY'], parseNumber, mergeNumbers, undefined);
  addPropertiesHandler(INHERIT_PROPERTIES, undefined, undefined, updateInherit);
  addPropertiesHandler(['x1', 'x2', 'y1', 'y2', 'r', 'rx', 'ry', 'width', 'height', 'path', 'points', 'text', 'shadowBlur', 'shadowOffsetX', 'shadowOffsetY', 'lineWidth', 'filter', 'font', 'fontSize', 'fontFamily', 'fontStyle', 'fontWeight', 'fontVariant', 'lineHeight', 'letterSpacing', // 'padding',
  'wordWrap', 'wordWrapWidth', 'leading', 'textBaseline', 'textAlign', 'whiteSpace'], undefined, undefined, updateGeometry);
  addPropertiesHandler(['fill', 'stroke', 'shadowColor'], parseColor, mergeColors, undefined);
  addPropertyHandler('clipPath', undefined, undefined, updateClipPath);
  addPropertyHandler('zIndex', undefined, undefined, updateZIndex);
  addPropertyHandler('offsetPath', undefined, undefined, updateOffsetPath);
  addPropertyHandler('offsetDistance', undefined, undefined, updateOffsetDistance);
  addPropertyHandler('origin', undefined, undefined, updateOrigin); // @ts-ignore

  addPropertyHandler('transformOrigin', undefined, undefined, updateTransformOrigin); // @ts-ignore

  addPropertyHandler('transform', parseTransform, mergeTransforms, updateTransform);
  addPropertyHandler('text', undefined, undefined, updateText);
  addPropertyHandler('textTransform', undefined, undefined, updateTextTransform); // Path.path
  // @ts-ignore

  addPropertyHandler('path', parsePath, mergePaths, undefined); // Polyline.points Polygon.points
  // @ts-ignore

  addPropertyHandler('points', parsePoints, undefined, undefined); // update local position

  addPropertiesHandler(['x', 'y', 'z', 'points', 'path', 'x1', 'x2', 'y1', 'y2', 'z1', 'z2'], undefined, undefined, updateLocalPosition);
  addPropertyHandler('filter', parseFilter, undefined, undefined);
  addPropertyHandler('anchor', undefined, undefined, updateAnchor);
});